import type { ReactNode } from 'react';
import type { WorkHours } from '@erectus/shared';
import { DayPicker, TimePicker } from '@/ui/pickers.js';

/**
 * When the user usually sits at a desk. The daily move reminder only goes out
 * inside these hours (shared/nudges.ts), at a different time each day.
 */
export function WorkHoursField({
  value,
  onChange,
}: {
  value: WorkHours;
  onChange(next: WorkHours): void;
}): ReactNode {
  const hours = (value.end - value.start) / 60;
  return (
    <div className="space-y-3">
      <DayPicker days={value.days} onChange={(days) => onChange({ ...value, days })} label="Work days" />
      <TimePicker
        label="From"
        minute={value.start}
        to={value.end - 60}
        onChange={(start) => onChange({ ...value, start })}
      />
      <TimePicker
        label="Until"
        minute={value.end}
        from={value.start + 60}
        to={24 * 60 - 30}
        onChange={(end) => onChange({ ...value, end })}
      />
      <p className="text-xs text-muted">
        About {Number.isInteger(hours) ? hours : hours.toFixed(1)} hours a day. One move reminder a day comes at a
        different time inside these hours, never outside them.
      </p>
    </div>
  );
}
